import Page from 'components/layout/Page';
import { WebOfferSummary } from 'model/model.web-offer-summary';
import { WithTranslation } from 'next-i18next';
import JoinUsBenefits from './JoinUsBenefits';
import { StyledJoinUs } from './JoinUsComponent.styled';
import JoinUsFooter from './JoinUsFooter';
import JoinUsHero from './JoinUsHero';
import JoinUsPositions from './JoinUsPositions';
import JoinUsTeam from './JoinUsTeam';
import JoinUsWhy from './JoinUsWhy';

type JoinUsComponentProps = {
  offers: WebOfferSummary[];
};

const JoinUsComponent: React.FC<JoinUsComponentProps & WithTranslation> = ({
  offers
}) => {
  return (
    <Page hasScrollTop topBarTransparent offerFooter={<JoinUsFooter />}>
      <StyledJoinUs>
        <JoinUsHero />
        <JoinUsTeam />
        <JoinUsWhy />
        <JoinUsBenefits />
        <JoinUsPositions offers={offers} />
      </StyledJoinUs>
    </Page>
  );
};

export default JoinUsComponent;
